import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    // Контроллер подключен
  }

  copy(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const text = this.urlValue
    
    if (!text) {
      this.showToast('Ошибка: URL не найден', true)
      return
    }

    // Пытаемся использовать современный API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.showToast('URL скопирован в буфер обмена')
      }).catch(() => {
        // Fallback для старых браузеров
        this.fallbackCopy(text)
      })
    } else {
      // Fallback для старых браузеров
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    document.body.appendChild(textArea)
    textArea.select()
    
    try {
      document.execCommand('copy')
      this.showToast('URL скопирован в буфер обмена')
    } catch (err) {
      this.showToast('Не удалось скопировать URL', true)
    }
    
    document.body.removeChild(textArea)
  }

  showToast(message, isError = false) {
    // Удаляем предыдущее уведомление, если есть
    const existingToast = document.querySelector('.toast-notification')
    if (existingToast) {
      existingToast.remove()
    }

    // Создаем новое уведомление
    const toast = document.createElement('div')
    toast.className = 'toast-notification' + (isError ? ' error' : '')
    toast.textContent = message
    document.body.appendChild(toast)

    // Удаляем уведомление через 3 секунды
    setTimeout(() => {
      toast.style.animation = 'fadeOut 0.3s ease-in'
      setTimeout(() => {
        toast.remove()
      }, 300)
    }, 2700)
  }
}

